
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { Advert } from '@/service';
import Swiper from './swiper.vue';
import SwiperItem from './swiper-item.vue';

/**
 * 广告场景
 * @enum 'index' - 首页
 * @enum 'checkstand' - 收银台
 * @enum 'success' - 支付成功
 * @enum 'user' - 用户中心
 */
type AdvertScene = 'index' | 'checkstand' | 'success' | 'user';

/* 广告位ID配置 */
const Config: Record<AdvertScene, string> | undefined = ({
    test: {
        index: '12-13-14-15',
        success: '17',
        checkstand: '27',
    },
    prod: {
        index: '13-14-15-16',
        success: '17',
        checkstand: '22',
    },
} as any)[window.SERVER_CONFIG.APP_ENV];

@Component({
    name: 'RrybAdvert',
    components: {
        Swiper,
        SwiperItem,
    },
})
export default class RrybAdvert extends Vue {
    // 广告场景
    @Prop({
        type: String,
        default: 'index',
    })
    private scene!: AdvertScene;

    // 广告激活状态
    private isActive: boolean = true;
    // 广告列表
    private adList: any[] = [];
    // 弹窗
    private showPopup: boolean = false;

    @Ref('swiperRef')
    private swiperRef!: any;

    // 广告组件激活
    // 针对轮播图在微信小程序的tab页onHide后继续监听切换的问题
    public active() {
        this.isActive = true;
    }

    // 广告组件失活
    public inactive() {
        this.isActive = false;
    }

    // 根据场景初始化广告数据
    public init() {
        if (!Config) {
            return;
        }
        const ids = Config[this.scene];
        this.getAdverts(ids);
    }

    // 广告监听
    public async advert(place: number, ad: number, isClick: boolean = false) {
        if (!this.isActive) {
            return;
        }
        try {
            await Advert.record({
                place_id: place,
                advert_id: ad,
                is_click: isClick ? 1 : 0,
                origin: 1,
            });
        } catch (err) {
            console.warn(err);
        }
    }

    // 广告展示
    public handleSwiperChange(current: number) {
        const target = (this.adList as any[])[current];
        this.advert(target.id, target.advert_id);
    }

    // 广告点击
    public handleAdvertClick({ url, id, advert_id }: any) {
        this.advert(id, advert_id, true);
        if (/^https?\:\/\//.test(url)) {
            window.location.href = url;
        }
    }

    // 获取广告
    public async getAdverts(ids: any) {
        if (!ids) {
            return;
        }
        try {
            let { data } = await Advert.list(ids);
            data = data ? data.filter((v: any) => v.place_status === 1 && v.is_count_limit !== 1) : [];
            this.adList = data;
            if (data.length) {
                this.advert(data[0].id, data[0].advert_id, false);
            }
        } catch (err) {
            console.warn(err);
        }
    }

    private created() {
        this.init();
    }
}
